<template>
  <div class="active-wrap" :class="{'is-respone': respone}">
    <div class="pic-wrap">
      <img class="m-img" :src="img" alt="">
    </div>
    <div class="active-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    img: String,
    // true 代表需要缩放图片
    respone: Boolean
  }
};
</script>

<style scoped>

.active-wrap {
  overflow: hidden;
  line-height: 1;
  position: relative;
}

.active-body {
  z-index: 2;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.pic-wrap {
  position: relative;
  img {
    border: 0 none;
    vertical-align: top;
  }
}

.is-respone {
  .pic-wrap {
    .m-img {
      width: 100%;
    }
  }
}

.active-wrap:not(.is-respone) {
  .pic-wrap {
    z-index: 1;
    width: 1000%;
    left: 50%;
    margin-left: -500%;
    text-align: center;
  }

  .active-body {
    width: 1920px;
    margin-left: -960px;
    left: 50%;
  }
}
</style>
